import { Head, useForm, usePage } from '@inertiajs/react'
import { Alert, Anchor, Button, Checkbox, Container, Group, Paper, PasswordInput, Stack, Text, TextInput, Title } from '@mantine/core'
import type { FormEvent } from 'react'
import type { SignInPageProps, SharedProps } from '@/types'

export default function New({ errors }: SignInPageProps) {
  const { csrf_token } = usePage<SharedProps>().props

  const { data, setData, post, processing } = useForm({
    user: {
      email: '',
      password: '',
      remember_me: false,
    },
    authenticity_token: csrf_token as string,
  })

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    post('/users/sign_in', { preserveScroll: true })
  }

  const emailError = errors?.email
    ? Array.isArray(errors.email)
      ? errors.email.join(', ')
      : errors.email
    : null

  return (
    <>
      <Head title="Sign in" />

      <Container size="xs" py={80}>
        <Paper component="form" onSubmit={handleSubmit} p="xl" radius="xl" shadow="md" withBorder>
          <Stack gap="lg">
            <Stack gap={4}>
              <Title order={2}>Sign in</Title>
              <Text c="dimmed">Welcome back.</Text>
            </Stack>

            {emailError ? (
              <Alert color="red" title="Could not sign you in">
                {emailError}
              </Alert>
            ) : null}

            <TextInput
              id="email"
              type="email"
              label="Email"
              autoComplete="email"
              value={data.user.email}
              onChange={(e) => setData('user', { ...data.user, email: e.target.value })}
            />

            <PasswordInput
              id="password"
              label="Password"
              autoComplete="current-password"
              value={data.user.password}
              onChange={(e) => setData('user', { ...data.user, password: e.target.value })}
            />

            <Group justify="space-between" align="center">
              <Checkbox
                id="remember_me"
                label="Remember me"
                checked={data.user.remember_me}
                onChange={(e) => setData('user', { ...data.user, remember_me: e.currentTarget.checked })}
              />
              <Anchor href="/users/password/new" size="sm">
                Forgot password?
              </Anchor>
            </Group>

            <Button type="submit" loading={processing}>
              Sign in
            </Button>

            <Text c="dimmed" size="sm" ta="center">
              Account creation is temporarily disabled.
            </Text>
          </Stack>
        </Paper>
      </Container>
    </>
  )
}
